import { gql } from "@/graphql/typed-gql"
import { NOTIFICATION_FIELDS } from "@/graphql/queries/notifications"

/**
 * Returns the refreshed feed rather than a bare success flag, so the badge and
 * the list update from the same answer the server just wrote — a refetch here
 * would race the poll and let the count flicker back.
 */
export const MARK_NOTIFICATIONS_READ = gql`
  mutation MarkNotificationsRead($studentId: ID!, $ids: [ID!]) {
    markNotificationsRead(studentId: $studentId, ids: $ids) {
      notifications {
        unreadCount
        items {
          ...NotificationFields
        }
      }
    }
  }
  ${NOTIFICATION_FIELDS}
`
